import { cachePolicy } from '@pn/core/cachePolicy';

export function isCacheStale(cacheTimestamp: number): boolean {
  return Date.now() - cacheTimestamp > cachePolicy.maxCacheAge;
}
